import React, { PropTypes } from 'react';
import uniqueId from 'lodash.uniqueid';
import $ from 'jquery';
import Portal from 'react-portal';

class InnerModal extends React.Component {
  static propTypes = {
    closable: PropTypes.bool,
    closePortal: PropTypes.func,
    children: PropTypes.node.isRequired,
    height: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      modalId: uniqueId('modal_'),
      style: {},
    };
  }

  componentDidMount() {
    let height = $(window).height() * 0.125 + 'px';
    if (this.props.height) {
      height = this.props.height;
    }
    this.setState({
      style: {
        position: 'relative',
        top: height,
      },
    });

    var modal = $('#' + this.state.modalId);

    var windowHeight = $(window).height();
    var modalHeight = modal.height();

    if (modalHeight + windowHeight * 0.125 > windowHeight) {
      var newContentHeight =
        modal.find('.content').height() +
        windowHeight * 0.875 -
        modalHeight -
        20;
      modal.find('.content').height(newContentHeight + 'px');
      modal.find('.content').css('overflow-y', 'auto');
    }
  }

  render() {
    const { closable, children, closePortal } = this.props;

    return (
      <div
        id={this.state.modalId}
        className="ui modal transition visible active"
        style={this.state.style}
      >
        {closable && <i className="close icon" onClick={closePortal} />}
        {children}
      </div>
    );
  }
}

const Modal = ({
  isOpened,
  onOpen,
  onClose,
  children,
  height,
  closable = false,
}) => (
  <Portal
    className="ui dimmer modals visible active page transition"
    onOpen={onOpen}
    isOpened={isOpened}
    onClose={onClose}
    closeOnEsc={closable}
    closeOnOutsideClick={closable}
  >
    <InnerModal closable={closable} closePortal={onClose} height={height}>
      {children}
    </InnerModal>
  </Portal>
);

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  isOpened: PropTypes.bool.isRequired,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  closable: PropTypes.bool,
  height: PropTypes.string,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/modules/common/components/Modal.js